import * as React from "react";
import ReactPlayer, { ReactPlayerProps } from "react-player";

const REACT_PLAYER_BASE_PROPS: ReactPlayerProps = {
  pip: false,
  playing: false,
  controls: false,
  light: false,
  volume: 1,
  muted: false,
  played: 0,
  loaded: 0,
  duration: 0,
  playbackRate: 1.0,
  loop: false,
};

export const VideoPlayer = (props: ReactPlayerProps) => {
  const { url, destinationUrl, ...rest } = props;
  const playerRef = React.useRef<ReactPlayer>(null);

  const res = {
        url,
        played: 0,
        loaded: 0,
        pip: false,
      }
  const videoProps = React.useMemo(
    () =>
      (res) as ReactPlayerProps,
    [url]
  );

  const playerProps: ReactPlayerProps = {
    width: "100%",
    height: "100%",
    ...REACT_PLAYER_BASE_PROPS,
    ...rest,
  };
  const merged = { ...playerProps, ...videoProps };
  return (
    <ReactPlayer
      ref={playerRef}
      {...merged}
      controls={false}
      // destinationUrl={undefined}
    />
  );
};
